import axios from 'axios';
import { getUrl } from '@/config/api.routes';
const basePath = 'management.campaign';
import { buildEncodedUrl } from '@/libs/urlencoding';


export default {
  namespaced: true,
  state: {
    campaigns: [],
    campaign: {},
  },
  mutations: {
    SET_CAMPAIGNS(state, campaigns) {
      state.campaigns = campaigns;
    },
    SET_CAMPAIGN(state, campaign) {
      state.campaign = campaign;
    },
  },
  actions: {
    async getCampaignList({ commit }, payload) {
      const [params, searchOffset] = payload;

      const url = buildEncodedUrl(
        getUrl(`${basePath}.campaign`),
        params,
      );

      const response = await axios.get(url);

      if (!searchOffset) {
        //append to previous list
        commit('SET_CAMPAIGNS', [...this.state.campaign.campaigns, ...response.data.models]);
      } else {
        commit('SET_CAMPAIGNS', response.data.models);
      }
      return response;
    },
    async getCampaign({ commit }, campaignId) {
      const response = await axios.get(getUrl(`${basePath}.campaign`, campaignId));
      commit('SET_CAMPAIGN', response.data);
      return response;
    },
    async createCampaign(_, payload) {
      const response = await axios.post(getUrl(`${basePath}.campaign`), payload);
      return response;
    },

    async updateCampaign(_, payload) {
      const { id, data } = payload;
      const response = await axios.put(getUrl(`${basePath}.campaign`, id), data);
      return response;
    },

    deleteCampaign(_, campaignId) {
      return axios.delete(getUrl(`${basePath}.campaign`, campaignId));
    },

    validateTemplate(_, name) {
      return axios.get(getUrl(`${basePath}.template`, name));
    },


    //customer campaign
    async createCustomerCampaign(_, payload) {
      const response = await axios.post(getUrl(`${basePath}.customers`), payload);
      return response;
    },
    async deleteCustomerCampaign(_, payload) {
      const {customerId, campaignId} = payload;
      return axios.delete(`${getUrl(`${basePath}.customers`) }/${customerId}/${campaignId}`);
    },

    async getCustomerCampaignList(_, payload) {
      const { customerId, executed} = payload;
      const response = axios.get(`${getUrl(`${basePath}.customers`) }/${customerId}`, { params: { executed } });
      return response;
    },

    async getCustomerCampaign(_, payload) {
      const {customerId, campaignId} = payload;
      const response = await axios.get(`${getUrl(`${basePath}.customers`) }/${customerId}/${campaignId}`);
      return response;
    },

    async terminateCustomerCampaign(_, payload) {
      const {customerId, campaignId} = payload;
      const response = await axios.put(`${getUrl(`${basePath}.terminate`) }/${customerId}/${campaignId}`);
      return response;
    },
  },
};
